import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import Asinc from '~/components/Common/Asinc';
import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';
import RatePlansGroupsForm from '~/components/Common/Forms/RatePlansGroupsForm';

import ReservationService from '~/services/ReservationService';
import VendorsService from '~/services/VendorsService';

export default class RatePlansGroupEditContainer extends Component {
  constructor(props) {
    super(props);

    const { match } = props;

    this.vendorId = match.params.id_vendor;
    this.fetchData = this.fetchData.bind(this);
  }

  async fetchData(vendorId) {
    const [schema, ratePlansGroups, vendor] = await Promise.all([
      ReservationService.getRatePlansGroupsSchema(vendorId),
      ReservationService.getRatePlansGroups(vendorId),
      VendorsService.getVendorById(vendorId),
    ]);

    return {
      schema: schema.put.body.schema,
      ratePlansGroups: ratePlansGroups.result,
      vendor: vendor.result,
    };
  }

  render() {
    return (
      <Container maxWidth="xl" className="rate-plans-groups-edit-form">
        <Asinc
          promise={this.fetchData(this.vendorId)}
          then={({ schema, ratePlansGroups, vendor }) => (
            <>
              <Helmet>
                <title>Vendors | {vendor?.name || this.vendorId} | Rate Plans Groups</title>
              </Helmet>

              <OfferBreadcrumbs
                vendor={{
                  label: vendor?.vendor_name || vendor?.name || 'Vendor',
                  href: `/vendors/${this.vendorId}`,
                }}
                currentPage="Rate plan groups"
              />
              <PageHeader title="Rate plan groups" />

              <Box id="overview" className="property-deal-section">
                <RatePlansGroupsForm schema={schema} ratePlansGroups={ratePlansGroups} vendorId={this.vendorId} />
              </Box>
            </>
          )}
        />
      </Container>
    );
  }
}
